import * as z from 'zod';

export const CreateTaxGroupRequest = z.object({
  taxGroup: z
    .object({
      _id: z
        .string()
        .describe('Tax group ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      name: z.string().describe('Tax group name.').min(1).max(200),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the tax group is updated. To prevent conflicting changes,\nthe current revision must be passed when updating the tax group.\n\nIgnored when creating a tax group.'
        )
        .optional()
        .nullable(),
      _createdDate: z
        .date()
        .describe('Date and time the tax group was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the tax group was last updated.')
        .optional()
        .nullable(),
    })
    .describe('Tax group to create.'),
});
export const CreateTaxGroupResponse = z.object({
  _id: z
    .string()
    .describe('Tax group ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  name: z.string().describe('Tax group name.').min(1).max(200).optional(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the tax group is updated. To prevent conflicting changes,\nthe current revision must be passed when updating the tax group.\n\nIgnored when creating a tax group.'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe('Date and time the tax group was created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time the tax group was last updated.')
    .optional()
    .nullable(),
});
export const GetTaxGroupRequest = z.object({
  taxGroupId: z
    .string()
    .describe('ID of the tax group to retrieve.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const GetTaxGroupResponse = z.object({
  _id: z
    .string()
    .describe('Tax group ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  name: z.string().describe('Tax group name.').min(1).max(200).optional(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the tax group is updated. To prevent conflicting changes,\nthe current revision must be passed when updating the tax group.\n\nIgnored when creating a tax group.'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe('Date and time the tax group was created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time the tax group was last updated.')
    .optional()
    .nullable(),
});
export const UpdateTaxGroupRequest = z.object({
  _id: z
    .string()
    .describe('Tax group ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  taxGroup: z
    .object({
      _id: z
        .string()
        .describe('Tax group ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      name: z.string().describe('Tax group name.').min(1).max(200),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the tax group is updated. To prevent conflicting changes,\nthe current revision must be passed when updating the tax group.\n\nIgnored when creating a tax group.'
        ),
      _createdDate: z
        .date()
        .describe('Date and time the tax group was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the tax group was last updated.')
        .optional()
        .nullable(),
    })
    .describe('Tax group info.'),
});
export const UpdateTaxGroupResponse = z.object({
  _id: z
    .string()
    .describe('Tax group ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  name: z.string().describe('Tax group name.').min(1).max(200).optional(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the tax group is updated. To prevent conflicting changes,\nthe current revision must be passed when updating the tax group.\n\nIgnored when creating a tax group.'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe('Date and time the tax group was created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time the tax group was last updated.')
    .optional()
    .nullable(),
});
export const DeleteTaxGroupRequest = z.object({
  taxGroupId: z
    .string()
    .describe('ID of the tax group to delete.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const DeleteTaxGroupResponse = z.object({});
export const QueryTaxGroupsRequest = z.object({
  query: z
    .object({
      filter: z
        .object({
          name: z
            .object({
              $eq: z.string(),
              $in: z.array(z.string()),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          _id: z
            .object({
              $eq: z.string(),
              $in: z.array(z.string()),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          _createdDate: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          _updatedDate: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          $and: z.array(z.any()).optional(),
          $or: z.array(z.any()).optional(),
          $not: z.any().optional(),
        })
        .strict()
        .optional(),
      sort: z
        .array(
          z.object({
            fieldName: z
              .enum(['name', '_id', '_createdDate', '_updatedDate'])
              .optional(),
            order: z.enum(['ASC', 'DESC']).optional(),
          })
        )
        .optional(),
    })
    .catchall(z.any())
    .describe('Query options.'),
});
export const QueryTaxGroupsResponse = z.object({
  taxGroups: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('Tax group ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        name: z.string().describe('Tax group name.').min(1).max(200).optional(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time the tax group is updated. To prevent conflicting changes,\nthe current revision must be passed when updating the tax group.\n\nIgnored when creating a tax group.'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe('Date and time the tax group was created.')
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe('Date and time the tax group was last updated.')
          .optional()
          .nullable(),
      })
    )
    .optional(),
  pagingMetadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items returned in current page.')
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe(
              'Cursor string pointing to the next page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to the previous page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe(
          'Cursor strings that point to the next page, previous page, or both.'
        )
        .optional(),
      hasNext: z
        .boolean()
        .describe(
          'Whether there are more pages to retrieve following the current page.\n\n+ `true`: Another page of results can be retrieved.\n+ `false`: This is the last page.'
        )
        .optional()
        .nullable(),
    })
    .describe('Paging metadata.')
    .optional(),
});
export const ListDefaultTaxGroupsRequest = z.object({});
export const ListDefaultTaxGroupsResponse = z.object({
  taxGroups: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('Tax group ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        name: z.string().describe('Tax group name.').min(1).max(200).optional(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time the tax group is updated. To prevent conflicting changes,\nthe current revision must be passed when updating the tax group.\n\nIgnored when creating a tax group.'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe('Date and time the tax group was created.')
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe('Date and time the tax group was last updated.')
          .optional()
          .nullable(),
      })
    )
    .optional(),
});
export const ListDefaultTaxGroupsByAppIdsRequest = z.object({
  appIds: z.array(z.string()).min(1).max(300),
});
export const ListDefaultTaxGroupsByAppIdsResponse = z.object({
  results: z
    .array(
      z.object({
        taxGroupMetadata: z
          .object({
            _id: z
              .string()
              .describe(
                "Item ID. Should always be available, unless it's impossible (for example, when failing to create an item)."
              )
              .optional()
              .nullable(),
            originalIndex: z
              .number()
              .int()
              .describe(
                'Index of the item within the request array. Allows for correlation between request and response items.'
              )
              .optional(),
            success: z
              .boolean()
              .describe(
                'Whether the requested action was successful for this item. When `false`, the `error` field is populated.'
              )
              .optional(),
            error: z
              .object({
                code: z.string().describe('Error code.').optional(),
                description: z
                  .string()
                  .describe('Description of the error.')
                  .optional(),
                data: z
                  .record(z.string(), z.any())
                  .describe('Data related to the error.')
                  .optional()
                  .nullable(),
              })
              .describe('Details about the error in case of failure.')
              .optional(),
          })
          .describe(
            'Information about success or failure to retrieve default tax groups.'
          )
          .optional(),
        taxGroup: z
          .object({
            _id: z
              .string()
              .describe('Tax group ID.')
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            name: z
              .string()
              .describe('Tax group name.')
              .min(1)
              .max(200)
              .optional(),
            revision: z
              .string()
              .regex(/^-?\d+$/, 'Must be a valid Int64 string')
              .describe(
                'Revision number, which increments by 1 each time the tax group is updated. To prevent conflicting changes,\nthe current revision must be passed when updating the tax group.\n\nIgnored when creating a tax group.'
              )
              .optional()
              .nullable(),
            _createdDate: z
              .date()
              .describe('Date and time the tax group was created.')
              .optional()
              .nullable(),
            _updatedDate: z
              .date()
              .describe('Date and time the tax group was last updated.')
              .optional()
              .nullable(),
          })
          .describe('Retrieved default tax groups.')
          .optional(),
      })
    )
    .min(1)
    .max(300)
    .optional(),
  bulkActionMetadata: z
    .object({
      totalSuccesses: z
        .number()
        .int()
        .describe('Number of items that were successfully processed.')
        .optional(),
      totalFailures: z
        .number()
        .int()
        .describe("Number of items that couldn't be processed.")
        .optional(),
      undetailedFailures: z
        .number()
        .int()
        .describe(
          'Number of failures without details because detailed failure threshold was exceeded.'
        )
        .optional(),
    })
    .describe('Bulk action metadata.')
    .optional(),
});
